function clipElement (elementId) {
    const element = document.getElementById(elementId)
    const text = element?.innerText?.trim() || ''

    navigator.clipboard.writeText(text)
        .then(() => {
            global.toastr.success('Content copied to clipboard')
        })
        .catch((err) => {
            console.error('Failed to copy: ', err)
        })
}

export default clipElement
